import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import * as moment from 'moment';
import { DateRange } from './DateRange';
import { Week } from './week';

@Component({
  selector: 'ls-calendar',
  templateUrl: './calendar.component.html'
})
export class CalendarComponent implements OnInit, OnChanges {
  // tslint:disable-next-line:no-input-rename
  @Input('range')
  public selectedDateRange: DateRange;
  // tslint:disable-next-line:no-input-rename
  @Input('month')
  public monthNumberToShow: number;
  // tslint:disable-next-line:no-input-rename
  @Input('min')
  public minMonth: moment.Moment;
  // tslint:disable-next-line:no-input-rename
  @Input('max')
  public maxMonth: moment.Moment;
  @Input()
  public singleDay = false;
  @Output()
  public dateSelected: EventEmitter<moment.Moment> = new EventEmitter<
    moment.Moment
  >();

  public weekdays: Array<string> = [];
  public weeks: Array<Week> = [];
  public month: moment.Moment;
  public monthName: string;

  public ngOnInit(): void {
    if (
      this.monthNumberToShow === undefined &&
      (this.selectedDateRange === undefined ||
        this.selectedDateRange.end === null)
    ) {
      this.month = moment().startOf('month');
    } else if (this.monthNumberToShow !== undefined) {
      this.month = moment()
        .month(+this.monthNumberToShow)
        .startOf('month');
    } else {
      this.month = moment(this.selectedDateRange.end).startOf('month');
    }

    this.weekdays = moment.weekdaysShort();
    this.calculateCalendar();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['monthNumberToShow'] &&
      changes['monthNumberToShow'].currentValue != null &&
      changes['monthNumberToShow'].currentValue !==
        changes['monthNumberToShow'].previousValue
    ) {
      this.month = moment()
        .month(+this.monthNumberToShow)
        .startOf('month');
      this.calculateCalendar();
    }

    if (
      changes['selectedDateRange'] &&
      this.selectedDateRange != null &&
      this.selectedDateRange.end != null
    ) {
      if (this.selectedDateRange.start.month() === this.monthNumberToShow) {
        this.month = this.selectedDateRange.start.clone().startOf('month');
        this.calculateCalendar();
      } else if (
        this.selectedDateRange.end.month() === this.monthNumberToShow
      ) {
        this.month = this.selectedDateRange.end.clone().startOf('month');
        this.calculateCalendar();
      }
    }

    if (
      changes['minMonth'] &&
      changes['minMonth'].currentValue !== changes['minMonth'].previousValue
    ) {
      if (this.minMonth && this.minMonth.isAfter(this.month, 'month')) {
        this.month = this.minMonth.clone().startOf('month');
      }
    }

    if (
      changes['maxMonth'] &&
      changes['maxMonth'].currentValue !== changes['maxMonth'].previousValue
    ) {
      if (this.maxMonth && this.maxMonth.isBefore(this.month, 'month')) {
        this.month = this.maxMonth.clone().startOf('month');
      }
    }
  }

  public previousMonth(): void {
    if (this.canGoToPreviousMonth(this.month, this.minMonth)) {
      this.month.add(-1, 'month');
      this.calculateCalendar();
    }
  }

  public nextMonth(): void {
    if (this.canGoToNextMonth(this.month, this.maxMonth)) {
      this.month.add(1, 'month');
      this.calculateCalendar();
    }
  }

  public isInDaterange(date: moment.Moment): boolean {
    if (
      this.selectedDateRange.end === null ||
      this.selectedDateRange.start === null
    ) {
      return false;
    }

    return date.isBetween(
      this.selectedDateRange.start,
      this.selectedDateRange.end,
      'day',
      '()'
    );
  }

  public isStartDate(date: moment.Moment): boolean {
    if (this.selectedDateRange.start === null) {
      return false;
    }

    return date.isSame(this.selectedDateRange.start, 'day');
  }

  public isEndDate(date: moment.Moment): boolean {
    if (this.selectedDateRange.end === null) {
      return false;
    }

    return date.isSame(this.selectedDateRange.end, 'day');
  }

  public selectDate(date: moment.Moment, event: MouseEvent): void {
    event.stopPropagation();
    this.dateSelected.emit(date);
  }

  public canGoToPreviousMonth(
    month: moment.Moment,
    minMonth: moment.Moment
  ): boolean {
    if (minMonth == null) {
      return true;
    }
    return month.isAfter(minMonth, 'month');
  }

  public canGoToNextMonth(
    month: moment.Moment,
    maxMonth: moment.Moment
  ): boolean {
    if (maxMonth == null) {
      return true;
    }
    return maxMonth.isAfter(month, 'month');
  }

  private calculateCalendar(): void {
    this.monthName = this.month.format('MMM') + ' ' + this.month.year();
    this.weeks = [];

    const currentDate: moment.Moment = this.month
      .clone()
      .date(-this.month.day() + 1);
    for (let i = 0; i < 6; i++) {
      const week: Week = {
        days: []
      };
      for (let j = 0; j < 7; j++) {
        week.days.push({
          day: currentDate.date(),
          date: currentDate.clone(),
          inCurrentMonth: currentDate.month() === this.month.month()
        });
        currentDate.add(1, 'day');
      }
      this.weeks.push(week);
    }
  }
}
